import { Injectable, signal } from '@angular/core';
import { Alert, AlertType } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private nextId = 0;
  readonly alerts = signal<Alert[]>([]);

  success(message: string): void {
    this.show(message, 'success');
  }

  error(message: string): void {
    this.show(message, 'danger', { autoDismiss: false });
  }

  warning(message: string): void {
    this.show(message, 'warning');
  }

  info(message: string): void {
    this.show(message, 'info');
  }

  dismiss(id: number): void {
    this.alerts.update((current) => current.filter((a) => a.id !== id));
  }

  clear(): void {
    this.alerts.set([]);
  }

  private show(
    message: string,
    type: AlertType,
    options?: { autoDismiss?: boolean; duration?: number },
  ): void {
    const id = this.nextId++;
    const autoDismiss = options?.autoDismiss ?? true;
    const duration = options?.duration ?? 4000;

    this.alerts.update((current) => [
      ...current,
      { id, type, message, dismissible: true, autoDismiss },
    ]);

    if (autoDismiss) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }
}
